
import { Component, Prop, Vue } from "vue-property-decorator";
import vIconWithTooltip from "@/components/vIconWithTooltip.vue";
import { round } from "@/utils/Helpers";
import { mapState } from "vuex";
import { RecipeBreakdown } from "@/models/Recipes/RecipeBreakdown";
import { RecipeIngredientBreakdown } from "@/models/Ingredient/RecipeIngredientBreakdown";
import { NutrientBreakdown } from "@/models/Recipes/RecipeBreakdown";

@Component({
  methods: { round },
  components: {
    vIconWithTooltip,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})

export default class vRecipeBreakdownTable extends Vue {
  @Prop() recipesCalculation: RecipeBreakdown;
  @Prop() tableHeaders: string[];
  @Prop() slicedTableHeaders: string[];
  @Prop() isAdmin: boolean;
  @Prop() useRoundedValues: boolean = false;

  localizationState: any;
  showChildRows: boolean[] = [];

  getNutrientFacts(){
    return this.recipesCalculation.nutrientFacts;
  }

  toggleChildRows(index: number): void {
    this.$set(this.showChildRows, index, !this.showChildRows[index]);
  }

  getNutrientValue(ingredient: RecipeIngredientBreakdown, nutrient: string) {
    const nutrientData = ingredient[nutrient as keyof RecipeIngredientBreakdown] || {
      per100Grams: { value: '-', unit: '' },
      inRecipe: { value: '-', unit: '' },
      inRecipeAfterLoss: { value: '-', unit: '' }
    };

    if(nutrient == "energy") {
      nutrientData.inRecipe.value = this.trialMaskedNutrientData(nutrientData.inRecipe.value);
      return nutrientData;
    }
    nutrientData.inRecipe.value = round(nutrientData.inRecipe.value, 2);
    return nutrientData;
  }

  getNutrientAbsoluteValue(nutrientKey: string) {
    const nutrient = this.recipesCalculation[nutrientKey];
    if (this.recipesCalculation[nutrientKey] != null) {
      if(nutrientKey == "energy"){
        nutrient.absoluteValue.value = this.trialMaskedNutrientData(nutrient.absoluteValue.value);
        return nutrient.absoluteValue;
      }
      if (this.recipesCalculation[nutrientKey].absoluteValue != null) {
        nutrient.absoluteValue.value = round(nutrient.absoluteValue.value, 2);
        return nutrient.absoluteValue;
      }
    }
    if (!nutrient) {
      return { value: 'N/A', unit: '' };
    }
  }

  getNutrientPerServingValue(nutrientKey: string) {
    const nutrient: NutrientBreakdown = this.recipesCalculation[nutrientKey];
    if (this.recipesCalculation[nutrientKey] != null) {
      if(nutrientKey == "energy"){
        nutrient.roundedValuePerServing.value = this.trialMaskedNutrientData(nutrient.roundedValuePerServing.value);
        nutrient.absoluteValuePerServing.value =  this.trialMaskedNutrientData(nutrient.absoluteValuePerServing.value);
        return this.useRoundedValues
          ? nutrient.roundedValuePerServing
          : nutrient.absoluteValuePerServing;
      }
      if (this.recipesCalculation[nutrientKey].absoluteValuePerServing != null) {
        nutrient.roundedValuePerServing.value = round(nutrient.roundedValuePerServing.value, 2);
        nutrient.absoluteValuePerServing.value = round(nutrient.absoluteValuePerServing.value, 2);
        return this.useRoundedValues
          ? nutrient.roundedValuePerServing
          : nutrient.absoluteValuePerServing;
      }
    }
    if (!nutrient) {
      return { value: 'N/A', unit: '' };
    }
  }

  trialMaskedNutrientData(value: number, shouldRound: boolean = true) {
    if (this.$store.getters.getUserDetails.isTrial) {
      return "--";
    }

    return shouldRound ? round(value, 2) : value;
  }

  overrideWeightDisplay(valueIfNotOverridden: number): string {
    return `${this.getNutrientFacts().overrideWeightPerServing || valueIfNotOverridden}${this.getNutrientFacts().overrideUnit || "g"}`;
  }
};
    